import Footer from '../../../components/Footer/Footer';
import { IRoute } from '../IRoute';

const FooterRoutes: IRoute[] = [
  // Non admin routes
  {
    component: Footer,
    default: true,
    key: '/'
  },
  // Admin routes
  {
    component: Footer,
    key: '/staff/*',
    path: '/staff/*'
  }
];

export default FooterRoutes;
